import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React, { useEffect, useState } from "react";
import Loader from "../../control-components/loader/loader";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { clinicService } from "../../services/clinicService";
import searchIcon from "../../assets/images/search.png";
import { Input } from "@progress/kendo-react-inputs";
import { useLocation } from "react-router";
import { Tooltip } from "@progress/kendo-react-tooltip";
import TemplateSettings from "../document-template/template-settings";
import DeleteDialogModal from "../../control-components/custom-delete-dialog-box/delete-dialog";
import { fileDocumentService } from "../../services/fileDocumentTemplateService";
import { NotificationManager } from "src/util/notify";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

function ClinicDeatils() {
    const { state } = useLocation();
    const regionData = state?.field?.regionId
    const masterClinicId = state?.field?.masterClinicId
    const clinicId = state?.field?.id
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(7);
    const [sort, setSort] = useState([]);
    const [selectedState, setSelectedState] = React.useState({});
    const [loading, setLoading] = useState(false);
    const [documentTemplate, setDocumentTemplate] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isTemplateSettingsOpen, setIsTemplateSettingsOpen] = useState(false)
    const [documentTemplateId, setDocumentTemplateId] = useState()
    const [isDeleteConfirm, setDeleteConfirm] = useState(false);
    const [selectedTemplateInfo, setSelectedTemplateInfo] = useState();

    useEffect(() => {
        getDocumentTemplateByClinic();
    }, []);

    useEffect(() => {
        setPage(0);
    }, [documentTemplate])

    const getDocumentTemplateByClinic = async () => {
        setLoading(true);
        await clinicService
            .getDocumentTemplateByClinic(regionData, masterClinicId)
            .then((result) => {
                if (result.resultData.length > 0) {
                    setDocumentTemplate(result.resultData);
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                NOTIFICATION_MESSAGE.error(error);
            });
    };

    const searchDocumentTemplateByName = async (regionData, masterClinicId, searchQuery) => {
        setLoading(true);
        await clinicService
            .searchDocumentTemplate(regionData, masterClinicId, searchQuery)
            .then((result) => {
                    setDocumentTemplate(result.resultData);
                    setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                NOTIFICATION_MESSAGE.error(error);
            });
    };


    const pageChange = (event) => {
        let skip = event.page.skip;
        let take = event.page.take;
        setPage(skip);
        setPageSize(take);
    };

    const handleFilter = (e) => {
        var search = e.target.value;
        setSearchQuery(search);
        if (search === "") {
            searchDocumentTemplateByName(regionData, masterClinicId, search);
        } else {
            if (search.length > 2) {
                searchDocumentTemplateByName(regionData, masterClinicId, search);
            }
        }
    };

    const handleTemplateSettings = (field) => {
        setIsTemplateSettingsOpen(!isTemplateSettingsOpen)
        setDocumentTemplateId(field?.id)
    }

    const unassignDocumentTemplate = async () => {
        setLoading(true);
        await fileDocumentService
            .unassignDocumentTemplate(clinicId, regionData, selectedTemplateInfo)
            .then((result) => {
                setLoading(false);
                setDeleteConfirm(!isDeleteConfirm);
                // setClinicList(clinicList.filter(item => item.masterClinicId !== selectedId));
                NotificationManager.success("Document template deleted successfully.");
                getDocumentTemplateByClinic()
            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.error(error);
                setDeleteConfirm(!isDeleteConfirm);
            });
    }

    const deleteSelectId = (field) => {
        setDeleteConfirm(!isDeleteConfirm);
        setSelectedTemplateInfo(field)
    }
    return (
        <>
            <h5 className="address-title text-grey ">
                Assigned Document Templates
            </h5>
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                <div className="content-search-filter ">
                    <img src={searchIcon} alt="" className="search-icon" />
                    <Input
                        className="icon-searchinput"
                        placeholder="Type min. 3 chars to find name"
                        value={searchQuery}
                        onChange={(e) => handleFilter(e)}
                    />
                </div>

            </div>
            <div className="grid-table  filter-grid">
                <div className=" mt-3">
                    <div className="inner-section-edit position-relative text-center">
                        <div className="grid-table  filter-grid header-blue">
                            <div className=" mt-3">
                                {loading === true ? <Loader />:

                                <Grid
                                    data={orderBy(documentTemplate.slice(page, pageSize + page), sort).map(
                                        (item) => ({
                                            ...item,
                                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                                        })
                                    )}
                                    checkboxElement
                                    style={{
                                        height: documentTemplate.length > 0 ? "100%" : "250px",
                                    }}
                                    dataItemKey={DATA_ITEM_KEY}
                                    selectedField={SELECTED_FIELD}
                                    skip={page}
                                    take={pageSize}
                                    total={documentTemplate.length}
                                    onPageChange={pageChange}
                                    pageable={{
                                        
                                    }}
                                    sort={sort}
                                    sortable={true}
                                    onSortChange={(e) => {
                                        setSort(e.sort);
                                    }}
                                >
                                    <GridColumn
                                        className="cursor-default"
                                        field="templateName"
                                        title="Template"
                                        width="200px"
                                    />
                                    
                                    <GridColumn
                                        // columnMenu={columnMenus}
                                        className="cursor-default"
                                        field="templateTypeName"
                                        title="Type"
                                        width="150px"
                                    />
                                    <GridColumn
                                        className="cursor-default"
                                        field="posType"
                                        title="POS"
                                        sortable={false}
                                        width="150px"
                                    />
                                    <GridColumn
                                        className="cursor-default"
                                        field="timeRecordingMethod"
                                        title="Time Recording"
                                        sortable={false}
                                        width="150px"
                                    />
                                    <GridColumn
                                        title="File Template?"
                                        sortable={false}
                                        width="150px"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.isHtmlFileTypeTemplate;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />

                                    <GridColumn
                                        sortable={false}
                                        width="185px"
                                        title="Can Apply Client Sig."

                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.canApplyClientSig;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>

                                            );

                                            }
                                        }}

                                    />
                                    <GridColumn
                                        sortable={false}
                                        width="180px"
                                        title="Show Client Progress"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showClientProgress;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />
                                    <GridColumn
                                        sortable={false}
                                        width="180px"
                                        title="Show Service Control"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showServiceControl;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />
                                    <GridColumn
                                        width="180px"
                                        sortable={false}
                                        title="Show Treatment Plan"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showTreatmentPlan;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />
                                    <GridColumn
                                        width="180px"
                                        sortable={false}
                                        title="Show Site of Service"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showSiteOfService;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />
                                    <GridColumn
                                        width="180px"
                                        sortable={false}
                                        title="Show Client Diagnosis"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showClientDiags;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />
                                    <GridColumn
                                        width="180px"
                                        sortable={false}
                                        title="Show Visit Type"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showVisitType;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />

                                    <GridColumn
                                        width="180px"
                                        sortable={false}
                                        title="Show Auths"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showAuths;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />

                                    <GridColumn
                                        width="180px"
                                        sortable={false}
                                        title="Show Add Dx (CP)"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showAddDiagnosis;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />

                                    <GridColumn
                                        width="180px"
                                        sortable={false}
                                        title="Show Add Goals (CP)"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showAddGoalObjInt;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />


                                    <GridColumn
                                        width="180px"
                                        sortable={false}
                                        title="Show Add Client Detail"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showAddDemographics;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />



                                    <GridColumn
                                        sortable={false}
                                        width="180px"
                                        title="Show File Attachment"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem.showFileAttachment;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />
                                    <GridColumn
                                        sortable={false}
                                        width="180px"
                                        title="Show Risk Assessment"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem?.showRiskAssessment;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />
                                    <GridColumn
                                        sortable={false}
                                        width="220px"
                                        title="Staff Signature Not Required"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem?.staffSignatureNotRequired;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />

                                    <GridColumn
                                        sortable={false}
                                        width="220px"
                                        title="Bypass Compliance"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem?.bypassCompliance;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />

                                    <GridColumn
                                        sortable={false}
                                        width="220px"
                                        title="Show EBP Code"
                                        cells={{
                                            data: (props) => {
                                            let field = props.dataItem?.showEbpCode;
                                            return (
                                                <td className="cursor-default">
                                                {field === true ? (
                                                    <span
                                                    className="fa fa-check-circle cursor-default  f-18 "
                                                    style={{ color: "green" }}
                                                    ></span>
                                                ) : (
                                                    <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                )}
                                                </td>
                                            );
                                            }
                                        }}
                                    />

                                    <GridColumn
                                        sortable={false}
                                        width="220px"
                                        title="Have Client Input Fields"
                                        cells={{
                                            data: (props) => {
                                                let field = props.dataItem?.clientFillable;
                                                return (
                                                    <td className="cursor-default">
                                                        {field ? (
                                                            <span
                                                                className="fa fa-check-circle cursor-default  f-18 "
                                                                style={{ color: "green" }}
                                                            ></span>
                                                        ) : (
                                                            <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                                                        )}
                                                    </td>
                                                );
                                            }
                                        }}
                                    />

                                    <GridColumn
                                        title="Action"
                                        width="120px"
                                        filterable={false}
                                        cells={{
                                            data: (props) => {
                                                let field = props.dataItem;
                                                return (
                                                    <td>
                                                        <div className="row-2">
                                                                    <div 
                                                                    onClick={() => deleteSelectId(field)}
                                                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red mr-2">
                                                                        <div className="k-chip-content"> 
                                                                        <Tooltip anchorElement="target" position="top">
                                                                            <i
                                                                                className="fa fa-trash"
                                                                                aria-hidden="true"
                                                                                title="Delete"
                                                                            ></i>
                                                                        </Tooltip>
                                                                        </div>
                                                                    </div>

                                                                    <div 
                                                                    onClick={() => handleTemplateSettings(field)} 
                                                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green mr-2">
                                                                         <div className="k-chip-content"> 
                                                                        <Tooltip anchorElement="target" position="top">
                                                                            <i
                                                                                className="fa fa-gear"
                                                                                aria-hidden="true"
                                                                                title="Settings"
                                                                            ></i>
                                                                        </Tooltip>
                                                                        </div>
                                                                    </div>
                                                        </div>
                                                    </td>
                                                );}
                                        }}
                                    />
                                </Grid>
}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isTemplateSettingsOpen && (
                <TemplateSettings
                onClose={handleTemplateSettings}
                regionId={regionData}
                isSelectedId={documentTemplateId}
                clinicId = {masterClinicId}
                // isHtml={isSelectedTempHtml}
                getAllDocumentTemplates = {getDocumentTemplateByClinic}
            />
            )}
            {isDeleteConfirm && (
                    <DeleteDialogModal
                        onClose={deleteSelectId}
                        title="Document Template"
                        message="document template"
                        handleDelete={unassignDocumentTemplate}
                    />
           )}
        </>
    );
}
export default ClinicDeatils;
